/**
 * 竞价结果
 */
import React from 'react';
import { Input, Row, Col, Icon, Tooltip, Select, DatePicker, Button } from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
//引入消息提示相关组件
import messager from '../../ui/messager';
import Loading from '../../ui/Loading';
//没收保证金
import AuctionConfiscateBond from './AuctionConfiscateBond';
//交易合同信息编辑
import AuctionContractEdit from './AuctionContractEdit';
//pdf文件展示
import PdfViewer from '../../ui/PdfViewer'
//详细信息展示
import AuctionLotsDetail from './AuctionLotsDetail';
//竞价结果录入
import AuctionResultEdit from './AuctionResultEdit';
import OrgSelect from '../../ui/OrgSelect';
import { global_data } from '../../ui/auth';

class AuctionResultIndex extends React.Component {
    columns = [{
        title: '所属市场',
        dataIndex: 'orgName',
        width: '10%',
    }, {
        title: '竞价品名称',
        dataIndex: 'name',
        width: '15%',
    }, {
        title: '车辆名称',
        dataIndex: 'vehicleIdsStr',
        width: '15%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '15%',
    // }, {
    //     title: '服务费',
    //     dataIndex: 'serviceChargeDictStr',
    //     width: '10%',
    }, {
        title: '竞价结束时间',
        dataIndex: 'endTime',
        width: '10%',
    }, {
        title: '竞价结果',
        dataIndex: 'status',
        width: '6%',
        format: { 0: '无人出价', 1: '成功', 2: '低于保留价', 3: '竞价成功，但没有成交' }
    }, {
        title: '成交价',
        dataIndex: 'finalPrice',
        width: '5%',
    }, {
        title: '成交会员',
        dataIndex: 'memberName',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '20%',
        render: (text, record, index) => (
            <div>
                <Tooltip title="详情">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
                {global_data.authCode.includes("AUCTION_RESULT_RESULT")?
                <Tooltip title="录入竞价结果信息">
                    <Icon type="highlight" theme="filled" className="table-operate-icon" onClick={this.updateLotsResult.bind(this, record)} />
                </Tooltip>
                :""}
                {record.status === 1 ?
                    <span>
                        {global_data.authCode.includes("AUCTION_RESULT_UPDATE")?
                        <Tooltip title="修改交易合同信息">
                            <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.updateContract.bind(this, record)} />
                        </Tooltip>
                        :""}
                        <Tooltip title="导出交易合同">
                            <Icon type="download" className="table-operate-icon" onClick={this.download.bind(this, record)} />
                        </Tooltip>
                        <Tooltip title="打印交易合同">
                            <Icon type="printer" theme="filled" className="table-operate-icon" onClick={this.print.bind(this, record)} />
                        </Tooltip>
                        {global_data.authCode.includes("AUCTION_RESULT_APPLY")?
                        <Tooltip title="提交过户申请">
                            <Icon type="upload" className="table-operate-icon" onClick={this.submit.bind(this, record)} />
                        </Tooltip>
                        :""}
                    </span>
                    : ""}
                {record.bondFreeze === 1 ?
                    <Tooltip title="解冻保证金">
                        <Icon type="unlock" theme="filled" className="table-operate-icon" onClick={this.unfreeze.bind(this, record)} />
                    </Tooltip>
                    : ""}
                {record.bondFreeze === 1 ?
                    <Tooltip title="没收保证金">
                        <Icon type="pay-circle" theme="filled" className="table-operate-icon" onClick={this.confiscate.bind(this, record)} />
                    </Tooltip>
                    : ""}
            </div>
        ),
    }];

    state = {
        visible: false, //编辑合同操作
        editData: {},  //编辑的数据
        loadData: '',
        queryData: {}, //查询数据

        confiscateVisible: false, //没收保证金操作
        detailVisible: false,

        loadingVisible: false,

        pdfVisible: false,

        editVisile: false, //编辑竞价结果信息
    };

    //修改合同
    updateContract = (info, e) => {
        this.setState({ loadingVisible: true });
        http.get({
            url: '/auctionResult/findLotsContractInfo',
            data: { lotsId: info.id },
            success: (res) => {
                this.initEdit(res);
                this.setState({ editData: res, visible: true, loadingVisible: false });
            },
            error: (res) => {
                messager.alert(res, "异常", "error");
                this.setState({ loadingVisible: false });
            }
        })
    }

    updateLotsResult = (info, e) => {
        this.setState({ loadingVisible: true });
        //读取竞价品信息
        http.get({
            url: '/auctionResult/findLotsDetail',
            data: { lotsId: info.id },
            success: (res) => {
                this.setState({ loadingVisible: false, editVisile: true, editData: res });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    //没收保证金
    confiscate = (info, e) => {
        this.setState({ editData: info, confiscateVisible: true });
    }

    //解冻保证金
    unfreeze = (info, e) => {
        messager.confirm("是否解冻该竞价品的保证金？", () => {
            http.post({
                url: '/auctionResult/unfreezeBond',
                data: { lotsId: info.id },
                success: (res) => {
                    this.state.loadData(this.queryData);
                    messager.notify("解冻成功！");
                }
            });
        });
    }

    download = (info, e) => {
        this.setState({ loadingVisible: true });
        http.download({
            url: "/auctionResult/downloadLotsContractInfo",
            data: { lotsId: info.id },
            fileName: "二手车交易合同.pdf",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    print = (info, e) => {
        this.setState({ loadingVisible: true });
        this.refs["pdfViewer"].loadFile({
            url: "/auctionResult/downloadLotsContractInfo",
            data: { lotsId: info.id },
            success: (res) => {
                this.setState({ loadingVisible: false, pdfVisible: true });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    submit = (info, e) => {
        messager.confirm("是否提交过户申请？过户申请前，请把合同信息完善。", () => {
            http.post({
                url: '/auctionResult/submitToTrade',
                data: { lotsId: info.id },
                success: (res) => {
                    this.state.loadData(this.queryData);
                    messager.notify("提交过户申请成功！");
                }
            });
        });
    }

    //详情
    detail = (info, e) => {
        this.setState({ loadingVisible: true });
        //读取竞价品信息
        http.get({
            url: '/auctionResult/findLotsDetail',
            data: { lotsId: info.id },
            success: (res) => {
                this.setState({ loadingVisible: false, detailVisible: true, editData: res });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    downloadLots = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "" || queryData.endDate == null || queryData.endDate === "") {
            messager.notify("导出时需选择时间段！", null, "warning");
            return;
        }
        this.setState({ loadingVisible: true });
        let fileName = queryData.startDate + "~" + queryData.endDate + " 竞价车辆信息.xlsx";
        http.download({
            url: '/auctionResult/downloadLots',
            data: queryData,
            fileName: fileName,
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    //查询
    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    selectChange = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //所属市场查询
    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="车辆名称或车架号"
                                    onSearch={this.inputSearch.bind(this, "vin")}
                                    enterButton
                                    style={{ width: '250px' }}
                                />
                                <OrgSelect style={{ width: '150px', margin: '0 10px' }}
                                    placeholder="所属市场"
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    treeDefaultExpandAll={true} />
                                <Input.Search
                                    placeholder="会员名称"
                                    onSearch={this.inputSearch.bind(this, "memberName")}
                                    enterButton
                                    style={{ width: '200px' }}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{margin: '0 10px' }}/>
                                <Select placeholder="竞价结果" defaultValue="" style={{ width: 150 }} onChange={this.selectChange.bind(this, "status")}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="1">成功</Select.Option>
                                    <Select.Option value="0">无人出价</Select.Option>
                                    <Select.Option value="2">低于保留价</Select.Option>
                                    <Select.Option value="3">竞价成功，但没有成交</Select.Option>
                                </Select>
                                <Button type="primary" onClick={this.downloadLots} style={{ float: "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/auctionResult/findLotsPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <AuctionConfiscateBond
                    visible={this.state.confiscateVisible}
                    onCancel={() => { this.setState({ confiscateVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <AuctionContractEdit
                    visible={this.state.visible}
                    onCancel={() => { this.setState({ visible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    initEdit={(func) => { this.initEdit = func }}
                />
                <PdfViewer
                    visible={this.state.pdfVisible}
                    onCancel={() => { this.setState({ pdfVisible: false }) }}
                    ref="pdfViewer"
                />
                <AuctionLotsDetail
                    visible={this.state.detailVisible}
                    onCancel={() => { this.setState({ detailVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                />
                <AuctionResultEdit
                    visible={this.state.editVisile}
                    onCancel={() => { this.setState({ editVisile: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <Loading visible={this.state.loadingVisible} message="处理中，请稍候..." />
            </div>
        )
    }

}

export default AuctionResultIndex;